import { render, staticRenderFns } from "./BaseInputFileDialog.vue?vue&type=template&id=537f452d&"
import script from "./BaseInputFileDialog.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports